import { render } from "./notificationlist.vue?vue&type=template&id=b5ff3a9c&scoped=true"
import script from "./notificationlist.vue?vue&type=script&lang=js"
export * from "./notificationlist.vue?vue&type=script&lang=js"

import "./notificationlist.vue?vue&type=style&index=0&id=b5ff3a9c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ff3a9c"]])

export default __exports__